(function() {
  'use strict';

  function findProductImg(card) {
    var selectors = [
      '.product-first-image img',
      '.card-product__media-inner img',
      '.card-product__media img',
      '.responsive-image img',
      'img.motion-reduce'
    ];
    for (var i = 0; i < selectors.length; i++) {
      var img = card.querySelector(selectors[i]);
      if (img) return img;
    }
    return null;
  }

  function storeOriginal(card) {
    var img = findProductImg(card);
    if (!img) return;
    var src = img.currentSrc || img.src || img.getAttribute('data-src') || '';
    if (src && src.indexOf('data:image') === -1 && src.length > 10) {
      card.dataset.originalImage = src;
      card.dataset.originalSrcset = img.getAttribute('srcset') || img.getAttribute('data-srcset') || '';
      card.dataset.originalAlt = img.alt || '';
    }
  }

  function initCard(card) {
    if (card.dataset.siblingInit) return;
    card.dataset.siblingInit = 'true';
    var img = findProductImg(card);
    if (img) {
      if (img.complete && img.naturalWidth > 0) {
        storeOriginal(card);
      } else {
        img.addEventListener('load', function() { storeOriginal(card); }, { once: true });
        setTimeout(function() { storeOriginal(card); }, 800);
        setTimeout(function() { storeOriginal(card); }, 2500);
      }
    }
  }

  function initAll() {
    document.querySelectorAll('[data-product-card]').forEach(function(card) {
      initCard(card);
    });
  }

  document.addEventListener('DOMContentLoaded', initAll);
  window.addEventListener('load', initAll);

  document.addEventListener('click', function(e) {
    var swatch = e.target.closest('.sibling-swatch-trigger');
    if (!swatch) return;
    e.preventDefault();
    e.stopPropagation();

    var card = swatch.closest('[data-product-card]');
    if (!card) return;

    initCard(card);

    var isActive = swatch.classList.contains('active');
    var newSrc, newSrcset, newAlt;

    if (isActive) {
      newSrc = card.dataset.originalImage || '';
      newSrcset = card.dataset.originalSrcset || '';
      newAlt = card.dataset.originalAlt || '';
    } else {
      newSrc = swatch.dataset.siblingImage || '';
      newSrcset = swatch.dataset.siblingImageSrcset || '';
      newAlt = swatch.dataset.siblingTitle || '';
    }

    if (!newSrc) return;

    var img = findProductImg(card);
    if (img) {
      img.removeAttribute('data-src');
      img.removeAttribute('data-srcset');
      img.removeAttribute('loading');
      img.classList.remove('lazy-image', 'lazyload', 'lazyloading');
      img.classList.add('lazyloaded', 'lazy-image-loaded');
      img.src = newSrc;
      if (newSrcset) {
        img.setAttribute('srcset', newSrcset);
      } else {
        img.removeAttribute('srcset');
      }
      img.alt = newAlt;
      img.style.opacity = '0.99';
      setTimeout(function() { img.style.opacity = ''; }, 50);
    }

    var clickedUrl = swatch.dataset.siblingUrl;
    if (clickedUrl) {
      card.querySelectorAll('a.product-link, a.full-unstyled-link').forEach(function(link) {
        link.href = clickedUrl;
      });
    }

    card.querySelectorAll('.sibling-swatch-trigger').forEach(function(s) {
      s.classList.remove('active');
    });
    swatch.classList.add('active');
  });

})();
